// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"47000736","410":"2229c423","744":"2d474e6b","801":"f6230b2a"}[chunkId] + ".chunk.js";
};